import { AvatarReport } from "@eclear-ag/ec-common-ui";

export default function Reports() {
  return (
    <div
      style={{
        background: "#FCFDFF",
        borderRadius: "8px",
        boxShadow:
          "inset -1px -1px 2px rgba(0, 0, 0, 0.08), inset 1px 1px 2px rgba(255, 255, 255, 0.6)",
        filter:
          "drop-shadow(-1px -1px 1px rgba(255, 255, 255, 0.6)) drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.06))"
      }}
    >
      <AvatarReport />
    </div>
  );
}
